import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=40b5a896&scoped=true&"
import script from "./step5.vue?vue&type=script&lang=js&"
export * from "./step5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5a896",
  null
  
)

export default component.exports